import React from 'react';
import { Button, HStack } from '@chakra-ui/react';
import { NextStep } from '~/pages/Portal/TechnicalSupport/index';
import { ROUTER_PATHS } from '~/constants';

interface StepButtonsProps {
  mudarDeTela: (step: NextStep) => void;
  step: NextStep;
  desabilitarProximo?: boolean;
}
export const StepButtons: React.VFC<StepButtonsProps> = ({
  mudarDeTela,
  step,
  desabilitarProximo = true,
}) => {
  return (
    <>
      {step.isBuscarNumeroSerie && (
        <HStack justifyContent="space-between" marginTop="5rem !important">
          <Button
            onClick={() => {
              const auxStep = { ...step };
              auxStep.isBuscarNumeroSerie = false;
              auxStep.isNaoEncontrado = true;
              mudarDeTela(auxStep);
            }}
          >
            Não encontrou o número de série?
          </Button>
          <Button
            color="white"
            background="gray.900"
            _hover={{
              bgColor: 'black',
            }}
            onClick={() => {
              const auxStep = { ...step };
              auxStep.isBuscarNumeroSerie = false;
              auxStep.isOpcoesSuporteTecnico = true;
              mudarDeTela(auxStep);
            }}
            isDisabled={desabilitarProximo}
          >
            Próximo
          </Button>
        </HStack>
      )}{' '}
      {(step.isNaoEncontrado || step.isCorrecting) && (
        <HStack justifyContent="end" gridGap={5}>
          <Button href={ROUTER_PATHS.PORTAL.TECHNICAL_SUPPORT} as="a">
            Voltar
          </Button>
          <Button
            color="white"
            background="gray.900"
            _hover={{
              bgColor: 'black',
            }}
            onClick={() => {
              const auxStep = { ...step };
              auxStep.isNaoEncontrado = false;
              auxStep.isOpcoesSuporteTecnico = true;
              auxStep.isCorrecting = false;
              mudarDeTela(auxStep);
            }}
          >
            Continuar sem o número de série
          </Button>
        </HStack>
      )}
      {step.isOpcoesSuporteTecnico && !step.isCorrecting && (
        <HStack justifyContent="end" marginTop="5rem !important" gridGap={5}>
          <Button
            onClick={() => {
              const auxStep = { ...step };
              auxStep.isOpcoesSuporteTecnico = false;
              auxStep.isFinalizarAtendimento = true;
              mudarDeTela(auxStep);
            }}
          >
            Finalizar atendimento
          </Button>
          <Button
            color="white"
            background="gray.900"
            _hover={{
              bgColor: 'black',
            }}
            onClick={() => {
              const auxStep = { ...step };
              mudarDeTela(auxStep);
            }}
            isDisabled={desabilitarProximo}
          >
            Próximo
          </Button>
        </HStack>
      )}
    </>
  );
};
